module.exports = __webpack_public_path__ + "static/media/ManagementView.29fe8971.less";


//////////////////
// WEBPACK FOOTER
// ./src/views/ManagementView/ManagementView.less
// module id = 3178
// module chunks = 0